// Single source of truth for the book published by Dr. Manisha Mishra
// (author) and Dr. Shantanu Kumar Gupta (editor). Used by the /book/squint-simplified
// landing page, the homepage credibility band, the two doctor pages, the
// sitemap and every JSON-LD emission. Keep exactly ONE canonical entry per
// book — extra data belongs in the landing page, not here.

export const BOOK_SQUINT = {
  slug: "squint-simplified",
  title: "Squint Simplified",
  subtitle: "A Complete Guide for Patients",
  fullTitle: "Squint Simplified: A Complete Guide for Patients",
  author: {
    name: "Dr. Manisha Mishra",
    role: "Author",
    url: "/team/dr-manisha-mishra",
  },
  editor: {
    name: "Dr. Shantanu Kumar Gupta",
    role: "Editor",
    url: "/about",
  },
  publisher: "Independently published (Amazon KDP)",
  publicationDate: "2026-08-09",
  language: "English",
  pages: 64,
  format: "Paperback",
  isbn13: "979-8189886089",
  asin: "B0HF1FMCB1",
  amazonUrl: "https://www.amazon.com/dp/B0HF1FMCB1",
  amazonInUrl: "https://www.amazon.in/dp/B0HF1FMCB1", // best-effort — Amazon serves the same ASIN cross-market when available
  coverImage: "/books/squint-simplified-cover.jpg",
  coverImageHiRes: "/books/squint-simplified-cover-1200.jpg",
  coverImageThumb: "/books/squint-simplified-cover-thumb.jpg",
  priceUSD: "10.00",
  synopsisShort:
    "A practical, easy-to-understand guide to squint (strabismus) — written by ophthalmologist Dr. Manisha Mishra to help patients and parents replace anxiety with clear, evidence-based information.",
  audience: [
    "Parents of children with crossed eyes or wandering eyes",
    "Adults living with squint, double vision or head-tilt",
    "Families evaluating squint surgery for a loved one",
    "Anyone who wants to understand strabismus in plain language",
  ],
  chapters: [
    "What squint (strabismus) is and why it occurs",
    "How our eyes normally work together",
    "The different types of squint",
    "Signs and symptoms that should never be ignored",
    "Why early diagnosis matters — especially in children",
    "What happens during a squint examination",
    "The role of glasses, patching, eye exercises, prism glasses & surgery",
    "What to expect before, during and after squint surgery",
    "Common myths and misconceptions about squint",
    "Answers to the most frequent patient questions",
  ],
};

export default BOOK_SQUINT;
